import { useEffect, useState } from 'react'

import { useWindowStore } from 'modules/desktop/pages/MainPage/stores'

export const useWindowStoreHydrated = (): boolean => {
  const [isHydrated, setIsHydrated] = useState(() =>
    useWindowStore.persist.hasHydrated()
  )

  useEffect(() => {
    if (useWindowStore.persist.hasHydrated()) {
      setIsHydrated(true)
      return
    }

    return useWindowStore.persist.onFinishHydration(() => {
      setIsHydrated(true)
    })
  }, [])

  return isHydrated
}
